import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Home, Scheduler, NotFound, RollingSim, Guides, RngSim } from "./Pages";
import { Navbar, Socials, RollingGame, Stats } from "./Components";
import PageStyle from "./Styles/PageStyle";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-LPV09JRDKE", {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
}

function App() {
  const [activeFilter, setActiveFilter] = React.useState("all");

  return (
    <Router>
      <AnalyticsTracker />
      <div className="flex flex-row w-screen">
        <div className="flex flex-row">
          <Socials />
        </div>
        <PageStyle>
          <div className="flex flex-col w-full">
            <div className="w-full max-h-max">
              <Navbar setActiveFilter={setActiveFilter} />
            </div>
            <Routes>
              <Route path="/" element={<Home activeFilter={activeFilter} />} />
              <Route path="/bountyscheduler" element={<Scheduler />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/rolling-simulator" element={<RollingSim />}>
                <Route index element={<RollingGame />} />
                <Route path="stats" element={<Stats />} />
                {/* Stats Component */}
              </Route>
              <Route path="/rng-visualizer" element={<RngSim />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </PageStyle>
      </div>
    </Router>
  );
}

export default App;
